import { Button, Row } from "antd";
import React, { useState } from "react";
import TmsModal from "../../../../../../components/tms-customs/tms-modal";
import TmsSmLicenseLeaseList from "../created-inner-pages/license-lease-list";
import TmsLicenseLeaseCreation from "../creation-inner-pages/tms-license-lease-creation";
const LicenseLease = () => {
  const [visible, setVisible] = useState(false);
  return (
    <div>
      <Row justify="start">
        <Button
          type="primary"
          onClick={() => {
            setVisible(true);
          }}
        >
          New License Lease
        </Button>
      </Row>
      <br />
      {!visible && <TmsSmLicenseLeaseList />}
      <TmsModal
        centered={true}
        width="80%"
        closable={false}
        visible={visible}
        title={"License lease Creation "}
        onClose={() => {
          setVisible(false);
        }}
      >
        {visible && <TmsLicenseLeaseCreation setVisible={setVisible} />}
      </TmsModal>
    </div>
  );
};

export default LicenseLease;
